var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.h2
    ? _c(
        "h2",
        {
          staticClass: "d-inline-block",
          attrs: { id: _vm.id && _vm.id.length > 0 ? _vm.id : "" }
        },
        [
          _c("b", [
            _vm._v(
              _vm._s(_vm.doNotUseResources ? _vm.title : _vm.$t(_vm.title))
            )
          ]),
          _vm._v(" "),
          _vm.instructionKey
            ? _c("tooltip-icon", {
                attrs: { content: _vm.$t(_vm.instructionKey) }
              })
            : _vm._e()
        ],
        1
      )
    : _vm.h4
    ? _c(
        "h4",
        {
          staticClass: "d-inline-block",
          attrs: { id: _vm.id && _vm.id.length > 0 ? _vm.id : "" }
        },
        [
          _c("b", [
            _vm._v(
              _vm._s(_vm.doNotUseResources ? _vm.title : _vm.$t(_vm.title))
            )
          ]),
          _vm._v(" "),
          _vm.instructionKey
            ? _c("tooltip-icon", {
                attrs: { content: _vm.$t(_vm.instructionKey) }
              })
            : _vm._e()
        ],
        1
      )
    : _c(
        "h3",
        {
          staticClass: "d-inline-block",
          attrs: { id: _vm.id && _vm.id.length > 0 ? _vm.id : "" }
        },
        [
          _c("b", [
            _vm._v(
              _vm._s(_vm.doNotUseResources ? _vm.title : _vm.$t(_vm.title))
            )
          ]),
          _vm._v(" "),
          _vm.instructionKey
            ? _c("tooltip-icon", {
                attrs: { content: _vm.$t(_vm.instructionKey) }
              })
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }